<template>
  <div class="contactInfo js-customScroll">
    <div class="contactInfo__section">
      <div class="contactInfo__title">contact us</div>
      <div class="contactInfo__list">
        <div class="contactInfo__list-item">
          <div class="contactInfo__list-itemTitle">Email</div>
          <a class="contactInfo__list-itemValue" href="mailto:FLY@flyjets.com">FLY@flyjets.com</a>
        </div>
        <div class="contactInfo__list-item">
          <div class="contactInfo__list-itemTitle">Phone</div>
          <a class="contactInfo__list-itemValue" href="tel:+12128455137">+1 (212) 845-5137</a>
        </div>
      </div>
      <div class="contactInfo__socials">
        <div class="contactInfo__socials-title">social</div>
        <div class="contactInfo__socials-list">
          <a class="contactInfo__socials-item" href="https://twitter.com/flyjetsflying" target="_blank"><SvgIcon name="tw"/></a>
          <a class="contactInfo__socials-item" href="https://www.instagram.com/flyjetsflying/" target="_blank"><SvgIcon name="inst"/></a>
          <a class="contactInfo__socials-item" href="https://www.facebook.com/flyjetsflying/" target="_blank"><SvgIcon name="fb"/></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SvgIcon from '@/components/common/SvgIcon/SvgIcon'
  import './Contact.styl'

  export default {
    props: ['whatsapp'],
    name: 'Contact',
    mounted () {
      console.log(this.whatsapp)
    },
    components: {
      SvgIcon,
    },
    metaInfo: {
      meta: [{
        name: 'robots', content: 'noindex',
      }],
    },
  }
</script>
